import React from 'react';
import PropTypes from 'prop-types';

const ImporterIcon = ({ importer }) => {
  if (importer.fa_icon) {
    return (
      <div className="icon-gray">
        <i
          className={importer.fa_icon}
          style={{ color: importer.fa_icon_color }}
        />
      </div>
    );
  }

  if (importer.icon_url) {
    return (
      <div
        className="icon-gray icon-image"
        style={{ backgroundImage: `url(${importer.icon_url}` }}
      />
    );
  }

  return null;
};

ImporterIcon.propTypes = {
  importer: PropTypes.object.isRequired,
};

export default ImporterIcon;
